const firebaseConfig = {
    apiKey: "AIzaSyArNY7gONX2juK9Zimp_p5cJPBbKYg81AE",
    authDomain: "repair-shop1.firebaseapp.com",
    projectId: "repair-shop1",
    storageBucket: "repair-shop1.appspot.com",
    messagingSenderId: "60745332113",
    appId: "1:60745332113:web:f56f09e0a820a51c329630"
  };
  export default firebaseConfig;